@import '../../theme/global';

:host {
  contain: strict;
  display: block;
  inset: 0;
  outline: 2px solid transparent;
  outline-offset: 2px;
  position: fixed;
  touch-action: none;
  user-select: none;
  z-index: 10001;

  ::slotted(snap-dropdown-menu-header) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

.action-sheet-wrapper {
  bottom: -100%;
  display: block;
  font-family: $font-family;
  height: 100%;
  left: 0;
  max-height: 100%;
  min-height: auto;
  min-width: auto;
  position: absolute;
  right: 0;
  width: 100%;
  z-index: 10;
}

.action-sheet-container {
  display: flex;
  flex-flow: column;
  height: 100%;
  justify-content: end;
  max-height: 100%;
}

.action-sheet-backdrop {
  background-color: rgba(0, 0, 0, 0.25);
  contain: strict;
  cursor: pointer;
  display: block;
  inset: 0;
  opacity: 0;
  position: absolute;
  touch-action: none;
  z-index: 2;
}

.action-sheet-group {
  background-color: $base-light;
  border: 1px solid #e2e8f0;
  border-radius: 20px 20px 0 0;
  padding: 15px 0;
}

.action-sheet-title {
  align-items: center;
  color: $gray-800;
  display: flex;
  font-size: 1rem;
  font-weight: 500;
  justify-content: space-between;
  line-height: 1.5rem;
  margin-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;

  &.no-title {
    margin-bottom: 0;
  }
}

.title-right {
  button {
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
  }
}

.draggable {
  margin-bottom: 1rem;
}

.action-sheet-move {
  background-color: $blue-600;
  border-radius: 0.125rem;
  height: 3px;
  margin: 0 auto;
  width: 58px;
}

.title-left {
  color: $gray-800;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
}
